import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const SKELETON_AREA_COUNT: number = 4;
const PILLS_PER_AREA: number[] = [4, 3, 5, 3];

const AreaAssetGridSkeleton = () => (
  <div className="area-asset-grid" aria-hidden>
    {Array.from({ length: SKELETON_AREA_COUNT }, (_, areaIndex: number) => {
      const pillCount: number = PILLS_PER_AREA[areaIndex] ?? 3;

      return (
        <div key={`area-asset-grid-skeleton-${areaIndex}`} className="area-asset-grid-card">
          <div className="area-asset-grid-card-header">
            <Skeleton variant="text" width="6rem" />
          </div>
          <div className="area-asset-grid-card-pills">
            {Array.from({ length: pillCount }, (_, pillIndex: number) => (
              <Skeleton
                key={`area-asset-grid-skeleton-${areaIndex}-pill-${pillIndex}`}
                variant="rect"
                width="9rem"
                height="2.4rem"
              />
            ))}
          </div>
        </div>
      );
    })}
  </div>
);

export default AreaAssetGridSkeleton;
